var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadUnderlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.49913 5.55556H12.1102L7.77691 9.88889L3.44358 5.55556H7.05469V0.5H8.49913V5.55556ZM1.99913 12.0556H13.5547V7H14.9991V12.7778C14.9991 12.9693 14.923 13.153 14.7876 13.2885C14.6522 13.4239 14.4685 13.5 14.2769 13.5H1.27691C1.08536 13.5 0.901664 13.4239 0.766221 13.2885C0.630779 13.153 0.554688 12.9693 0.554688 12.7778V7H1.99913V12.0556Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadUnderlined);
export default __webpack_public_path__ + "static/media/downloadUnderlined.67a17f6ade922fb2fcd4a30b4bc2fae7.svg";
export { ForwardRef as ReactComponent };